import React from 'react';
import { IconButton, Menu, MenuItem, ListItemText, Tooltip } from '@mui/material';
import { Translate } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { isRtlLanguage } from '../i18n/rtl';

const languages = [
  { code: 'de', label: 'Deutsch', flag: 'DE' },
  { code: 'en', label: 'English', flag: 'EN' },
  { code: 'fr', label: 'Français', flag: 'FR' },
];

const LanguageSelector = ({ sx, onDirectionChange }) => {
  const { t, i18n } = useTranslation('common');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    const rtl = isRtlLanguage(code);
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    document.documentElement.lang = code;
    if (onDirectionChange) {
      onDirectionChange(rtl ? 'rtl' : 'ltr');
    }
    handleClose();
  };

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <>
      <Tooltip title={currentLang.label} arrow>
        <IconButton
          onClick={handleClick}
          aria-label={t('app.changeLanguage', 'Sprache wechseln')}
          aria-haspopup="true"
          aria-expanded={open}
          size="small"
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2.5,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
            color: 'text.primary',
            '&:hover': { bgcolor: 'action.hover' },
            ...sx,
          }}
        >
          <Translate size={20} weight="duotone" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === i18n.language}
            onClick={() => handleLanguageChange(lang.code)}
          >
            <ListItemText primary={lang.label} secondary={lang.flag} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
